export async function baseUrlEncoder(url: string, outputFormat = 'image/png'): Promise<any> {
    if (url.indexOf('base64') !== -1) { return url; } else {
        const result = await new Promise(function (resolve, reject) {
            let canvas: any = document.createElement('CANVAS');
            const ctx = canvas.getContext('2d');
            const img = new Image;
            img.crossOrigin = 'Anonymous'; // 重点！设置image对象可跨域请求
            img.onload = function () {
                // scale
                canvas.height = 280;
                canvas.width = 360;
                ctx.drawImage(img, 0, 0, 360, 280);
                const dataURL = canvas.toDataURL(outputFormat);
                canvas = null;
                resolve(dataURL);
            };
            img.src = url + '?tamp=' + (new Date()).valueOf();
           //  img.src = 'https://placekitten.com/1000/300';
        });
        return result;
    }
}

export function dataURItoBlob(dataURI: string) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    const byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
}

export function capitalize(str: string) {
    const init = str[0].toUpperCase();
    return init + str.slice(1, str.length);
}
